module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Cyrus Winchester opened his eyes and blinked in confusion. He appeared to be in a hospital room. From down the hall came the sound of a television advertisement for an end-of-season fall sale.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He told himself he must be dreaming. The last thing he remembered was heading to Montana to spend the Fourth of July with the grandmother he hadn’t seen in twenty-seven years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Glancing toward the window, he saw a gap in the drapes. His heart began to pound. The leaves were gone off the trees and several inches of fresh snow covered the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A nurse entered the room, but she didn’t look in his direction as she went over to the window and opened the curtains. He closed his eyes again, blinded by the brightness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he tried to make sense of this, Cyrus could hear her moving around the room. She came over to the bed, tucking and straightening, humming to herself a tune he didn’t recognize. She smelled of citrus, a light, sweet scent that reminded him of summer and driving to Montana with the windows down on his pickup, the radio blaring.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a start, he realized that wasn’t the last thing he remembered!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His hand shot out, grabbing the nurse’s wrist. She screamed, drawing back in surprise, eyes widening in shock. What was wrong with her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He opened his mouth, his lips working, but nothing came out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t try to talk,” she said and pushed the call button with her free hand. “The doctor will be glad to see that you’re back with us, cowboy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Back with us?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cyrus tried again to speak, desperate to tell her what he remembered, but the only sound that came out was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shh.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse gently removed her wrist from his grasp to pour him a glass of water. “Here, drink a little of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gratefully he took the cup from her and raised his head enough to take a sip. He couldn’t believe how weak he felt or how confused he was. But one thought remained clear and that was what he urgently needed to tell someone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took another swallow of water, feeling as if he hadn’t had a drink in months.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sheriff.” The word came out in a hoarse whisper. “Get. The. Sheriff. I saw it. The nurse. Murdered. In the hospital nursery.”")])])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-154b65fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426869167_ch01.vue
// module id = 78
// module chunks = 0